import ConsentProvider from "./ConsentProvider";
class NetlifeConsentProvider extends ConsentProvider {
    constructor(onChangeCallback) {
        super();
        this.allowTracking = window.ntlfConsentAllowTracking;
        this.onChangeCallback = onChangeCallback;
        console.log("On change callback", onChangeCallback);
        // Trigger the current value on load to notify the providers
        this.getAllowTracking = this.getAllowTracking.bind(this);
    }
    getAllowTracking() {
        return this.allowTracking;
    }
    handleConsentPush() {
        return false;
    }
    setAllowTracking(value) {
        this.allowTracking = value;
        this.onChangeCallback(this.allowTracking);
        const date = new Date();
        // EU seems to be ok with expiration times up to 13 months.
        //   Until determined otherwise it is set to 1 year here.
        date.setTime(date.getTime() + 31536000000);
        const cookieValue = value ? "1" : "0";
        document.cookie =
            "cookieConsent=" +
                cookieValue +
                ";" +
                "expires=" +
                date.toUTCString() +
                ";path=/;";
    }
}
export default NetlifeConsentProvider;
